import Admin from './controllers/Admin/module';
import Common from './Common/module';
import Google from './Google/module';

const Application = {
    Admin,
    Common,
    Google
};

export default Application;